export default "__VITE_ASSET__8031c23f__"